module.exports = __webpack_public_path__ + "static/media/cosera.102de84c.jpeg";